<template>
    <div>
        <sav-template :title="$t('home.title')" :back-button="false">
            <continue-card v-if="formWaiting" class="mb-4"></continue-card>
            <div v-else class="p-6 my-2 text-center shadow my-rounded" style="background: #006e31; color: #fff">
                <h3 class="mb-1">
                    <i class="mr-2 fas fa-plus-circle"></i>{{$t('accueil.demande_de_sav')}}
                </h3>
                <p>
                    <small>{{$t('accueil.un_souci_avec_un_produit_il_vous_suffit_de_commencer_une_nouvelle_demande_de_sav')}}</small>
                </p>
                <router-link :to="{ name: 'form.home'}" class="text-white text-decoration-none">
                    <button class="inline-block px-3 py-2 mt-3 font-normal leading-normal text-center text-white no-underline whitespace-no-wrap align-middle rounded select-none" style="background: #005927;"> {{$t('accueil.commencer')}} </button>
                </router-link>
            </div>
            <template v-if="refusedRequests.length > 0">
                <small class="block my-3">{{$t('accueil.casino.demande_de_sav_refusees')}}</small>
                <div v-for="item in refusedRequests" :key="item.id" class="mb-3">
                    <sav-fold-card :title="item.modele" v-model="item.isOpen" :state="item.etat">
                        <template v-slot:open>
                            <h6 class="mt-3">{{$t('accueil.casino.numero_de_demande')}}</h6>
                            <span class="text-gray-600"> {{ item.id }} </span>
                            <hr>
                            <h6>{{$t('accueil.casino.date_demande')}}</h6>
                            <span class="text-gray-600"> {{ item.date_demande }} </span>
                            <hr>
                            <h6>{{$t('accueil.casino.date_d_achat')}}</h6>
                            <span class="text-gray-600"> {{ item.date_achat }} </span>
                            <hr>
                            <h6>{{$t('accueil.casino.ean')}}</h6>
                            <span class="text-gray-600"> {{ item.ean }} </span>
                            <template v-if="item.commentaire">
                                <hr>
                                <h6>{{$t('accueil.casino.commentaire')}}</h6>
                                <span class="text-gray-600"> {{ item.commentaire }} </span>
                            </template>
                            <template v-if="item.ticketPicture">
                                <hr>
                                <h6 class="mb-3">{{$t('accueil.casino.justificatif_d_achat')}}</h6>
                                <img :src="item.ticketPicture.url" class="block mx-auto" style="max-height: 350px; max-width: 100%">
                            </template>
                            <template v-if="item.nameplatePicture">
                                <hr>
                                <h6 class="mb-3">{{$t('accueil.casino.plaque_signaletique')}}</h6>
                                <img :src="item.nameplatePicture.url" class="block mx-auto" style="max-height: 350px; max-width: 100%">
                            </template>
                            <hr>
                            <div class="text-center">
                                <button @click="editRequest(item)" class="inline-block px-3 py-1 mr-2 font-normal leading-normal text-center text-white no-underline whitespace-no-wrap align-middle bg-green-500 border rounded select-none hover:green-600">
                                    <i class="mr-1 fas fa-edit"></i>{{$t('accueil.casino.modifier')}}
                                </button>
                                <!-- TODO: Implémenter la requête de suppression -->
                                <button class="inline-block px-3 py-1 font-normal leading-normal text-center text-white no-underline whitespace-no-wrap align-middle bg-red-600 border rounded select-none hover:bg-red-700">
                                    <i class="mr-1 fas fa-trash-alt"></i>{{$t('accueil.casino.supprimer')}}
                                </button>
                            </div>
                        </template>
                    </sav-fold-card>
                </div>
            </template>
        </sav-template>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import ContinueCard from '@/processes/cards/other/ContinueCard.vue'

export default {
    components: { ContinueCard },

    data() {
        return {
            client_id: null,
            loading: false,
            refusedRequests: [],
        }
    },

    computed: {
        formWaiting() {
            return localStorage.getItem('form-data') ? true : false
        }
    },

    methods: {
        async getSavRequests() {
            this.loading = true
            await apiService.post('getrequestapp', {
                id_conso: this.client_id
            }).then((response) => {
                let data = response.data.posts.post
                let onlyRefusedRequest = data.find(element => element.etat == 2)
                this.refusedRequests = onlyRefusedRequest && onlyRefusedRequest.length > 0 ? onlyRefusedRequest : []
                this.getFiles()
                this.loading = false
            })
        },

        getFiles() {
            this.refusedRequests.forEach((item, index) => {
                if (item.id_justif) {
                    this.getFile(index, item.id_justif, 'ticketPicture')
                }
                if (item.id_plaque) {
                    this.getFile(index, item.id_plaque, 'nameplatePicture')
                }
            })
        },

        async getFile(index, id, name) {
            await apiService.post('getfile', {
                id_conso: this.client_id,
                id_file: id
            }).then((response) => {
                this.requests[index][name] = response.data.posts.post
            })
        },
        
    },

    async mounted() {
        this.client_id = this.$crypto.decrypt(localStorage.getItem('client_id'))
        this.getSavRequests()
    }
}
</script>



// WEBPACK FOOTER //
// src/companies/casino/views/Home.vue